__turbopack_context__.v({
  "ShortInterestTableWrap": "styles-module-scss-module__hKgMNq__ShortInterestTableWrap",
  "TitleContainer": "styles-module-scss-module__hKgMNq__TitleContainer",
  "ant-table-column-has-sorters": "styles-module-scss-module__hKgMNq__ant-table-column-has-sorters",
});
